
import { apiGet } from '@/services/BaseApiService';

export const getAttributes = async() => {
    const url = `/getattributes`;
    return apiGet(url);
};
